export default __webpack_public_path__ + "static/media/illustration-recruit-3-m.a8390396.webp";